namespace GeniuzPOS.Administration {
    export interface PsPosProcessModeRow {
        Id?: number;
        PosProcessMode?: string;
        PosProcessModeName?: string;
    }

    export namespace PsPosProcessModeRow {
        export const idProperty = 'PosProcessMode';
        export const nameProperty = 'PosProcessModeName';
        export const localTextPrefix = 'Administration.PsPosProcessMode';
        export const lookupKey = 'Administration.PsPosProcessMode';

        export function getLookup(): Q.Lookup<PsPosProcessModeRow> {
            return Q.getLookup<PsPosProcessModeRow>('Administration.PsPosProcessMode');
        }
        export const deletePermission = '1POSBASE:โปรไฟล์ของกิจการ:พารามิเตอร์ระบบ:Modify';
        export const insertPermission = '1POSBASE:โปรไฟล์ของกิจการ:พารามิเตอร์ระบบ:Modify';
        export const readPermission = '1POSBASE:โปรไฟล์ของกิจการ:พารามิเตอร์ระบบ:View';
        export const updatePermission = '1POSBASE:โปรไฟล์ของกิจการ:พารามิเตอร์ระบบ:Modify';

        export declare const enum Fields {
            Id = "Id",
            PosProcessMode = "PosProcessMode",
            PosProcessModeName = "PosProcessModeName"
        }
    }
}
